import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import AssociationMultiAutocompleteBoxViewModelType from '@/ViewModels/Controls/AssociationMultiAutocompleteBoxViewModel';
import LinkType from '@/Controls/Link';
import MultiSelectAutoCompleteType from '@/Controls/MultiSelectAutoComplete';
import CheckBoxType from '@/Controls/CheckBox';

export default class AssociationMultiAutocompleteBox extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private MultiSelectAutoComplete = ComponentManager.getControl<typeof MultiSelectAutoCompleteType>('MultiSelectAutoComplete');

    private jQueryControl: JQuery;
    public multiSelectAutoComplete: MultiSelectAutoCompleteType;
    public linkCreate: LinkType;
    public linkSelect: LinkType;

    public constructor(private viewModel: AssociationMultiAutocompleteBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'associationmultiautocompletebox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.multiSelectAutoComplete != null) {
            this.multiSelectAutoComplete = new this.MultiSelectAutoComplete(this.viewModel.multiSelectAutoComplete);
            let tuple = this.multiSelectAutoComplete.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkCreate != null) {
            this.linkCreate = new this.Link(this.viewModel.linkCreate);
            let tuple = this.linkCreate.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkSelect != null) {
            this.linkSelect = new this.Link(this.viewModel.linkSelect);
            let tuple = this.linkSelect.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }

    public addLabelReference(label: JQuery): JQuery {
        return this.multiSelectAutoComplete.addLabelReference(label);
    };
}

ComponentManager.setControl('AssociationMultiAutocompleteBox', AssociationMultiAutocompleteBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');